module.exports = ".first-line,.second-line{left:0px}.second-line{top:10px}.active-step{background-color:#55b1bd !important;color:#FFF}\n"